import BaseImage from 'components/wrappers/ui/BaseImage/BaseImage'

export default BaseImage
